import InvoiceListPanel from '@/pages/dashboard/finance/components/InvoiceListPanel';

export default function FinanceFacturesPage() {
  return <InvoiceListPanel docType="invoice" />;
}